import { createFileRoute } from "@tanstack/react-router";
import RefundPolicyPage from "@/pages/legal/RefundPolicyPage";

export const Route = createFileRoute("/refund")({
  head: () => ({
    meta: [
        {
            "title": "Politique de remboursement | System Atlas"
        },
        {
            "name": "description",
            "content": "Conditions de remboursement et d'annulation des abonnements System Atlas, essai gratuit de 7 jours inclus."
        },
        {
            "property": "og:title",
            "content": "Politique de remboursement | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Conditions de remboursement et d'annulation des abonnements System Atlas, essai gratuit de 7 jours inclus."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/refund"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Politique de remboursement | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Conditions de remboursement et d'annulation des abonnements System Atlas, essai gratuit de 7 jours inclus."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/refund"
        }
    ],
  }),
  component: RefundPolicyPage,
});
